/**
 * Преобразует строку categoriesView в строку с категориями для аналитики.
 */
export const formatCategories = (categoriesView: string): string => {
  return categoriesView.replace(/ и /g, ',').replace(/, /g, ',').replace(/\s/g, '_');
};
